import { Typography } from '@mui/material';
import { UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IntakeQuoteLineItem } from '../../IntakeQuoteStep.schema';
import { I18nNamespace } from '~/common/types';

import { useTotalLineItemFormat } from './IntakeQuoteStepLineItemTotal.hooks';

type IntakeRequestStepLineItemTotalProps = {
  watch: UseFormWatch<IntakeQuoteLineItem>;
};
export const IntakeQuoteStepLineItemTotal = ({ watch }: IntakeRequestStepLineItemTotalProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeQuoteLineItemStepForm' });

  const [pricePerUnit, quantity] = watch(['pricePerUnit', 'quantity']);

  const { formatTotal } = useTotalLineItemFormat();
  return (
    <>
      <Typography variant="subtitle2" sx={{ marginTop: '8px' }} color="textSecondary">
        {t('totalValue')}
      </Typography>
      <Typography variant="h6">{formatTotal({ pricePerUnit, quantity })}</Typography>
    </>
  );
};
